import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      // 実際のAPIが実装されるまでダミー処理
      setTimeout(() => {
        // ダミーユーザー情報
        const userData = {
          id: 1,
          email: formData.email,
          businessName: 'サンプルカフェ',
          businessType: 'カフェ'
        };
        const token = 'dummy-token-12345';
        
        login(userData, token);
        navigate('/');
      }, 1000);
      
      // 実際のAPI実装時はこちらを使用
      // const response = await fetch('/api/auth/login', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify(formData)
      // });
      // 
      // if (!response.ok) {
      //   const errorData = await response.json();
      //   throw new Error(errorData.message || 'ログインに失敗しました');
      // }
      // 
      // const data = await response.json();
      // login(data.user, data.token);
      // navigate('/');
    } catch (error) {
      setError(error.message || 'ログインに失敗しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>AI職人くん</h1>
          <p>店舗SNS投稿作成サービス</p>
        </div>
        
        <h2>ログイン</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">メールアドレス</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">パスワード</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
          
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>アカウントをお持ちでない方は <Link to="/register">新規登録</Link></p>
 <p><Link to="/">ダッシュボードへ（テスト用）</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
